module.exports = tribe.common.components;